import { render } from "./ImportCardType.vue?vue&type=template&id=90cfafde&scoped=true"
import script from "./ImportCardType.vue?vue&type=script&lang=js"
export * from "./ImportCardType.vue?vue&type=script&lang=js"

import "./ImportCardType.vue?vue&type=style&index=0&id=90cfafde&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90cfafde"]])

export default __exports__